var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3779_25835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38659 6.60546C7.61756 6.60546 8.61547 5.60755 8.61547 4.37658C8.61547 3.1456 7.61756 2.14771 6.38659 2.14771C5.15561 2.14771 4.15771 3.1456 4.15771 4.37658C4.15771 5.60755 5.15561 6.60546 6.38659 6.60546Z",
    fill: "#D7E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80127 9.43986C10.8915 10.166 10.1553 11.5665 8.84538 11.5665H3.92617C2.61623 11.5665 1.88003 10.166 2.97029 9.43986C3.94823 8.78852 5.12267 8.40894 6.38577 8.40894C7.64887 8.40894 8.82332 8.78852 9.80127 9.43986Z",
    fill: "#D7E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38659 6.60546C7.61756 6.60546 8.61547 5.60755 8.61547 4.37658C8.61547 3.1456 7.61756 2.14771 6.38659 2.14771C5.15561 2.14771 4.15771 3.1456 4.15771 4.37658C4.15771 5.60755 5.15561 6.60546 6.38659 6.60546Z",
    stroke: "#0157FF",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80127 9.43986C10.8915 10.166 10.1553 11.5665 8.84538 11.5665H3.92617C2.61623 11.5665 1.88003 10.166 2.97029 9.43986C3.94823 8.78852 5.12267 8.40894 6.38577 8.40894C7.64887 8.40894 8.82332 8.78852 9.80127 9.43986Z",
    stroke: "#0157FF",
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.813965 1.23671L1.67111 0.43335",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.813965 3.64681L4.24254 0.43335",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.813965 6.45864L2.56274 4.81958",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24221 0.433594L7.02832 0.634066",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.880371 9.20864L3.4702 6.78125",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2426 0.433594L9.37744 1.24443",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1353 8.0322L11.9336 7.28394",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2451 3.24273L11.9365 1.65747",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40576 6.84146L11.9336 4.47217",
    stroke: "#0157FF",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3779_25835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.375)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.844e033fcbc6320076eea4339445721f.svg";
export { ForwardRef as ReactComponent };